import ContentHome from "src/components/modules/home";

const HomePage = () => {
  return <ContentHome />;
};

export default HomePage;
